import type React from 'react';

import MentionInput from '../../../mention_input/mention_input';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'placeholderPrefix',
  'onKeyDown',
  'mentionsMode',
  'allowSearchUsers',
  'onClick',
  'autoFocus',
] as const;

const Field = formField(MentionInput, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

type MentionFieldWrapperProps = FieldWrapperProps<typeof Field>;

const MentionsInputFieldWrapper: React.FC<MentionFieldWrapperProps> = (
  props,
) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default MentionsInputFieldWrapper;
